// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
require('./../Sass/base.scss');

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
require('babel-polyfill');

import {CDNHandler} from "../../../Assets/Js/CDNHandler";
import * as helper from './../../../Assets/Js/helper';
import {isInsideViewport} from "./insideViewport";
import {touchStartHandler, touchMoveHandler, touchEndHandler} from "./TabletSwipeHandler";

let paytourSettings;

helper.onDocumentLoaded(async () => {
	const ab1 = parseInt(helper.getData(helper.$('#wrapper'), 'ab1'));
	const previewImages: HTMLImageElement[] = helper.$('.video-thumb img');
	const video: HTMLVideoElement = helper.$('#video');
	const documentWidth = window.document.body.getBoundingClientRect().width;
	const paytourLinks = helper.$('.paytour');
	const cdn = new CDNHandler();
	let cdnDomain = await cdn.getCdnDomain();
	let mainDomain = await cdn.getMainDomain();

	paytourSettings = {
		lpId: 'VXTube2',
		hideSignupConfirmation: true,
		targetUrl: '',
		pfm: 1502,
		host: 0,
		option: '2XITGA',
		hideClose: false,
		minAmount: 2500, // cents
		disableJump: true,
		conversion: {
			signup: {
				background: `https://${mainDomain}/VX/VxTube2/img/signupteaser_desktop_100prozent.jpg`, // hier das Bild ersetzen
				backgroundMobile: `https://${mainDomain}/VX/VxTube2/img/signupteaser_mobile.jpg`,
				headerHeadlineMobile: "VISIT-X schenkt dir 100% Bonus auf deine Aufladung (bis zu 100 Euro).",
				backgroundMobileWidth: 120
			}
		}
	};

	if (ab1 === 1) {
		paytourSettings = Object.assign(paytourSettings, {
			texts: {
				BonusTextCustom: "& erhalte 3 Premium-Videos gratis"
			}
		})
		paytourSettings.option = "TUBE3VIDEOS";
		paytourSettings.conversion.signup.background = `https://${mainDomain}/VX/VxTube2/img/signupteaser_desktop_3gratisvideos.jpg`
		paytourSettings.conversion.signup.headerHeadlineMobile = "VISIT-X schenkt dir einen Gutschein für 3 Premium-Videos deiner Wahl.";
	}

	for (const link of paytourLinks) {
		helper.addEventListener(link, 'click', (evt: MouseEvent) => {
			evt.preventDefault();
			window.paytourHelper.openPaytour(paytourSettings);
		})
	}

	const clickHandler = () => {
		window.paytourHelper.openPaytour(paytourSettings);
	};

	for (const image of previewImages) {
		helper.addEventListener(image, 'click', clickHandler)
	}

	helper.addEventListener(video, 'click', clickHandler)

	const syncVideoToImage = (image: HTMLImageElement) => {
		const url = image.src;
		const rect = image.getBoundingClientRect();
		const left = rect.x || rect.left;
		const top = rect.y || rect.top;

		video.style.left = left + 'px';
		video.style.top = (top + window.pageYOffset)  + 'px';
		video.style.width = rect.width + 'px';
		video.style.height = rect.height + 'px';
		video.src = `https://${cdnDomain}/vxtube/${url.split('/').pop().replace('_420x236.jpg', '_FastCut_420x236.mp4')}`;
		helper.show(video);
	}

	if (documentWidth <= 576 ) {
		// Phone - single line
		let lastSyncedImage;
		const scrollHandler = () => {
			for (const image of previewImages) {
				if (isInsideViewport(image)) {
					if (lastSyncedImage !== image) {
						syncVideoToImage(image);
						lastSyncedImage = image;
					}
					break;
				}
			}
		}

		helper.addEventListener(window, 'scroll', helper.debounce(scrollHandler, 150));

	} else if (documentWidth >= 1084) {
		// Desktop (hopefully)
		const hoverHandler = (e) => {
			syncVideoToImage(e.target);
		}

		for (const image of previewImages) {
			helper.addEventListener(image, 'mouseenter', hoverHandler);
		}

		helper.addEventListener(video, 'mouseleave', () => {
			helper.hide(video);
		})
	} else {
		// Tablets
		for (const image of previewImages) {
			helper.addEventListener(image, 'touchstart', touchStartHandler);
			helper.addEventListener(image, 'touchmove', touchMoveHandler);
			helper.addEventListener(image, 'touchend', touchEndHandler.bind(null, image,() => {
				syncVideoToImage(image)
			}));
		}

	}
})
